import { makeResetMutation } from '@utils/reset-store'
import { clonarPayload } from '@modules/ws/utils/clonarPayload'
import { buildInitialState } from './state'

// Mutations
export const SET_OPERATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.operations.data = payload
    state.operations.lastUpdate = new Date()
  }
}
export const ADD_OPERATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.operations.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.operations.data.push(data)
      }
    })
  }
}
export const SET_OPERATIONS_LOADING = (state, payload) => {
  state.operations.loading = payload
}
export const REMOVE_OPERATION = (state, payload) => {
  if (payload === null || payload === undefined) {
    return
  }
  const isObject = typeof payload === 'object'
  const idToRemove = isObject ? payload.id : payload
  const idOperacaoToRemove = isObject ? payload.id_operacao : null

  // Locally-created operations have only `id_operacao` (no backend `id` yet),
  // while persisted ones have both. The filter keeps an item only if NEITHER
  // identifier matches.
  if (idToRemove == null && idOperacaoToRemove == null) {
    return
  }

  state.operations.data = state.operations.data.filter((item) => {
    if (idToRemove != null && item.id === idToRemove) return false
    if (idOperacaoToRemove != null && item.id_operacao === idOperacaoToRemove) return false
    return true
  })
}

export const SET_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clients.data = payload
    state.clients.lastUpdate = new Date()
  }
}
export const ADD_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clients.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clients.data.push(data)
      }
    })
  }
}
export const SET_CLIENTS_LOADING = (state, payload) => {
  state.clients.loading = payload
}

export const SET_CLIENT_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientAssets.data = payload
    state.clientAssets.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clientAssets.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientAssets.data.push(data)
      }
    })
  }
}
export const SET_CLIENT_ASSETS_LOADING = (state, payload) => {
  state.clientAssets.loading = payload
}

export const SET_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.assets.data = payload
    state.assets.lastUpdate = new Date()
  }
}
export const ADD_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.assets.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.assets.data.push(data)
      }
    })
  }
}
export const SET_ASSETS_LOADING = (state, payload) => {
  state.assets.loading = payload
}

export const SET_ASSETS_METADATA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.assets.metadata = payload
  }
}
export const SET_CLIENT_ACCOUNT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientAccount.data = payload
    state.clientAccount.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_ACCOUNT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clientAccount.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientAccount.data.push(data)
      }
    })
  }
}
export const SET_CLIENT_ACCOUNT_LOADING = (state, payload) => {
  state.clientAccount.loading = payload
}

export const SET_CLIENT_EXTRACT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientExtract.data = payload
    state.clientExtract.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_EXTRACT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clientExtract.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientExtract.data.push(data)
      }
    })
  }
}
export const SET_CLIENT_EXTRACT_LOADING = (state, payload) => {
  state.clientExtract.loading = payload
}
export const SET_CLIENT_EXTRACT_METADATA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientExtract.metadata = payload
  }
}

export const SET_TRANCHES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.tranches.data = payload
    state.tranches.lastUpdate = new Date()
  }
}
export const ADD_TRANCHES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.tranches.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.tranches.data.push(data)
      }
    })
  }
}
export const SET_TRANCHES_LOADING = (state, payload) => {
  state.tranches.loading = payload
}

export const SET_CASHBACK = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.cashback.data = payload
    state.cashback.lastUpdate = new Date()
  }
}
export const ADD_CASHBACK = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.cashback.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.cashback.data.push(data)
      }
    })
  }
}
export const SET_CASHBACK_LOADING = (state, payload) => {
  state.cashback.loading = payload
}

// RESET: restaura o state inicial (libera clientes/operações do escritório
// anterior retidos entre trocas de perfil in-SPA). [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)

export const SET_SOLICITACOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.solicitacoes.data = payload
    state.solicitacoes.lastUpdate = new Date()
  }
}
export const ADD_SOLICITACOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.solicitacoes.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.solicitacoes.data.push(data)
      }
    })
  }
}
export const SET_SOLICITACOES_LOADING = (state, payload) => {
  state.solicitacoes.loading = payload
}
// Catálogo de frentes (áreas) + serviços (tipos) da esteira Backoffice —
// mesmo padrão de SET_ASSETS_METADATA (campo extra fora do trio padrão).
export const SET_SOLICITACOES_CATALOGO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.solicitacoes.catalogo = {
      areas: Array.isArray(payload.areas) ? payload.areas : [],
      tipos: Array.isArray(payload.tipos) ? payload.tipos : [],
    }
  }
}

